import { transport } from '../../transport';
import {
  APPLICATION_PATH,
  BASE_PATH,
  PROJECT_PATH,
  WEBHOOKS_PATH,
} from '../config';

function _getPath({ organizationId, projectId, applicationId }) {
  return `${BASE_PATH}/${organizationId}${PROJECT_PATH}/${projectId}${APPLICATION_PATH}/${applicationId}${WEBHOOKS_PATH}`;
}

function createWebhook(webhook, { organizationId, projectId, applicationId }) {
  return transport.post(
    _getPath({ organizationId, projectId, applicationId }),
    webhook,
  );
}

function updateWebhook(webhook, { organizationId, projectId, applicationId }) {
  return transport.put(
    _getPath({ organizationId, projectId, applicationId }),
    webhook,
  );
}

// TODO: make delete request with DELETE method type
function deleteWebhook({ url }, { organizationId, projectId, applicationId }) {
  return transport.post(
    `${_getPath({ organizationId, projectId, applicationId })}/delete`,
    { url },
  );
}

function _activateWebhook(
  webhook,
  { organizationId, projectId, applicationId },
) {
  return transport.put(
    `${_getPath({ organizationId, projectId, applicationId })}/activate`,
    webhook,
  );
}

function _deactivateWebhook(
  { url },
  { organizationId, projectId, applicationId },
) {
  return transport.put(
    `${_getPath({ organizationId, projectId, applicationId })}/deactivate`,
    { url },
  );
}

function toggleWebhookActivity(webhook, params) {
  const method = webhook.active ? _deactivateWebhook : _activateWebhook;
  return method(webhook, params);
}

function sendWebhookTest(params: {
  applicationId: string;
  webhookUrl: string;
}) {
  return transport.post('/webhooks/test', params);
}

export const webhookService = {
  createWebhook,
  updateWebhook,
  deleteWebhook,
  toggleWebhookActivity,
  sendWebhookTest,
};
